// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import auditDocumentEntity from './entities/audit-document.json';
import auditDocumentMenu from '../pages/audit-document/menu.json';
import auditDocumentFullForm from '../pages/audit-document/forms/full.json';
import auditDocumentContextForm from '../pages/audit-document/forms/context.json';
import auditDocumentMiniForm from '../pages/audit-document/forms/mini.json';
import auditDocumentLookupForm from '../pages/audit-document/forms/lookup.json';
import auditDocumentTableView from '../pages/audit-document/views/table.json';
import auditDocumentCardsView from '../pages/audit-document/views/cards.json';
import auditDocumentCalendarView from '../pages/audit-document/views/calendar.json';
import auditDocumentDashboardView from '../pages/audit-document/views/dashboard.json';

/** Тип запису «Документ аудиту» зі сторінками пакета: меню, форми та подання з pages/audit-document/. */
export const auditDocumentDefinition: IRecordTypeDefinition = {
  ...auditDocumentEntity,
  views: assembleViewSet({
      table: auditDocumentTableView,
      cards: auditDocumentCardsView,
      calendar: auditDocumentCalendarView,
      dashboard: auditDocumentDashboardView,
  }),
  form: auditDocumentFullForm,
  forms: { full: auditDocumentFullForm, context: auditDocumentContextForm, mini: auditDocumentMiniForm, lookup: auditDocumentLookupForm },
  menu: auditDocumentMenu,
} as IRecordTypeDefinition;
